<lms-list
  [listId]="listId"
  [serviceProvider]="groupQuestionsService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="question"
      label="customizations.documents.questions.text"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="right"
      label="customizations.documents.questions.numAnswers"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="text"
      label="customizations.documents.questions.correctAnswer"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="right"
      label="customizations.documents.questions.correct"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="wrong"
      label="customizations.documents.questions.incorrect"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="wildcard"
      label="customizations.documents.questions.wildcard"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="createdBy"
      label="customizations.documents.questions.author"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="status"
      label="customizations.documents.questions.status"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="likes"
      label="customizations.documents.questions.likes"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="dislikes"
      label="customizations.documents.questions.dislikes"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="created_at"
      label="customizations.documents.questions.creationDate"
    ></lms-list-header>
    <div class="table-item"></div>
  </div>
  <lms-group-questions-list-row
    class="table-row"
    *ngFor="let question of questions"
    [question]="question"
  ></lms-group-questions-list-row>
</lms-list>
